var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex flex-row" }, [
    _c(
      "div",
      { staticClass: "action-button flex flex-row items-center mr-4" },
      [
        _c(
          "span",
          {
            staticClass: "prev mr-2",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.prev()
              },
            },
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "9",
                  height: "12",
                  viewBox: "0 0 9 12",
                  fill: "none",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M7.96845 5.27018e-08C8.38229 0.148546 8.52119 0.489684 8.5552 0.912842C8.57854 1.20143 8.56961 1.48941 8.56961 1.77769C8.57105 4.78536 8.57134 7.79273 8.56932 10.8001C8.56903 11.0294 8.55664 11.2588 8.47422 11.4781C8.32148 11.8846 7.99122 12.0705 7.58401 11.9757C7.34135 11.9192 7.1255 11.8019 6.92262 11.6558C4.83095 10.147 2.73958 8.63813 0.648775 7.12807C0.394017 6.94398 0.180759 6.71949 0.0738416 6.40509C-0.080339 5.95216 0.0118803 5.54753 0.300067 5.18482C0.493441 4.9415 0.752523 4.78475 0.996041 4.60887C2.95226 3.19571 4.9102 1.78467 6.86671 0.37182C7.09092 0.209909 7.32838 0.0786782 7.59064 8.57314e-08C7.71657 7.47215e-08 7.84251 6.37117e-08 7.96845 5.27018e-08Z",
                    fill: "#979797",
                  },
                }),
              ]
            ),
          ]
        ),
        _c(
          "span",
          {
            staticClass: "next",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.next()
              },
            },
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "10",
                  height: "12",
                  viewBox: "0 0 10 12",
                  fill: "none",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M1.17413 12C0.76029 11.8515 0.621384 11.5103 0.587378 11.0872C0.564035 10.7986 0.572968 10.5106 0.572968 10.2223C0.571528 7.21464 0.571239 4.20727 0.573257 1.19991C0.573545 0.970557 0.585937 0.741207 0.668359 0.521882C0.821098 0.115432 1.15136 -0.0704779 1.55857 0.0242997C1.80122 0.0808018 2.01708 0.198059 2.21996 0.344174C4.31163 1.85302 6.403 3.36187 8.4938 4.87193C8.74856 5.05602 8.96182 5.28051 9.06874 5.59491C9.22292 6.04784 9.1307 6.45247 8.84251 6.81518C8.64914 7.0585 8.39005 7.21525 8.14654 7.39113C6.19032 8.80429 4.23237 10.2153 2.27587 11.6282C2.05166 11.7901 1.81419 11.9213 1.55194 12C1.426 12 1.30007 12 1.17413 12Z",
                    fill: "#979797",
                  },
                }),
              ]
            ),
          ]
        ),
      ]
    ),
    _c("div", {}, [
      _c("span", { staticClass: "mr-2 title" }, [_vm._v(_vm._s(_vm.title))]),
      _c("span", { staticClass: "trail" }, [_vm._v(_vm._s(_vm.trailingText))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }